/**
 * 检测是否在小程序 web-view 环境中
 */
export function isInMiniProgram(): boolean {
  if (window.__wxjs_environment) {
    const isMiniProgram = window.__wxjs_environment.includes("miniprogram")
    return isMiniProgram
  }
  return false
}

/**
 * 设置小程序标题（仅在小程序环境生效）
 * @param title 标题文本
 */
export function setMiniProgramTitle(title: string): void {
  if (isInMiniProgram()) {
    document.title = title
  }
}
